import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ServiceBase } from '../shared/servicebase'
import { Observable } from 'rxjs';
import { Helper } from '../shared/Helper';

@Injectable({
  providedIn: 'root'
})
export class SincronismoService extends ServiceBase {

  private readonly emailTestSecret = 'facinatus-email-test-7d8c2a91f436e50b6a049d327ef881c3';

  constructor(private emailHttp: HttpClient) {
    super(emailHttp);

  }

  public UploadCliente(arquivo) {
    return this.UploadFile('sincronismo/UploadCliente/', arquivo);
  }
  public UploadProduto(arquivo) {
    return this.UploadFile('sincronismo/UploadProdutos/', arquivo);
  }

  public UploadCidadeEstado(arquivo) {
    return this.UploadFile('sincronismo/UploadCidadeEstado/', arquivo);
  }

  Pedidos(dtInicio, dtFim, codCliente, nrPedido): Observable<any[]> {
    var obj = {
      dtInicio: dtInicio,
      dtFim: dtFim,
      codCliente: codCliente,
      nrPedido: nrPedido
    };
    return this.SetValue('sincronismo/pedidos', obj);
  }

  DownloadPedido(pedidoId: string): Observable<any> {
    return this.GetPDF('sincronismo/downloadpedido/' + pedidoId);
  }
  SendMailVendedor(pedidoId: string, usuarioId, empresa: string): Observable<any> {
    return this.GetValue('sincronismo/sendmailvendedor/' + usuarioId + '/' + pedidoId + '/' + empresa);
  }  

  Filtrar(filtro:string): Observable<any>{        
    return this.GetValue<any>('sincronismo/filtrar/' + filtro);
  }

  ObterConfiguracaoEmailAtual(): Observable<any> {
    return this.emailHttp.get<any>(
      Helper.baseApiUrl + 'Sincronismo/ConfiguracaoEmailAtual',
      { headers: this.getEmailTestHeaders() }
    );
  }

  TestarEmail(requisicao: any): Observable<any> {
    return this.emailHttp.post<any>(
      Helper.baseApiUrl + 'Sincronismo/TestarEmail',
      requisicao,
      { headers: this.getEmailTestHeaders() }
    );
  }

  private getEmailTestHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Facinatus-Email-Test-Secret': this.emailTestSecret
    });
  }

  

}
